import { render, staticRenderFns } from "./TaxonGroup.vue?vue&type=template&id=41f8f46c&"
import script from "./TaxonGroup.vue?vue&type=script&lang=js&"
export * from "./TaxonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports